__turbopack_context__.v({
  "className": "avenirnextdemi_e8ca7220-module__ndbODW__className",
  "variable": "avenirnextdemi_e8ca7220-module__ndbODW__variable",
});
